<template>
  <div style="height: 100%">
    <div id="assetsEcharts" class="echart-box"></div>
  </div>
</template>

<script>
export default {
  props: {
    balanceInfor: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    balanceInfor(val) {
      if (val) {
        this.resetData();
      }
    },
  },
  data() {
    return {

    };
  },
  computed: {
    serveData() {
      const arr = [];

      if (this.balanceInfor.isolateMargin && Number(this.balanceInfor.isolateMargin) !== 0) {
        arr.push({
          value: this.balanceInfor.isolateMargin,
          name: this.$t('futures.assetsChart.text1'), // '逐仓',
          itemStyle: { normal: { color: '#1752FC' } },
          label: { fontFamily: 'Medium' },
        });
      }
      if (this.balanceInfor.totalMargin && Number(this.balanceInfor.totalMargin) !== 0) {
        arr.push({
          value: this.balanceInfor.totalMargin,
          name: this.$t('futures.assetsChart.text2'), // '全仓',
          itemStyle: { normal: { color: '#51BC86' } },
          label: { fontFamily: 'Medium' },
        });
      }
      if (this.balanceInfor.lockAmount && Number(this.balanceInfor.lockAmount) !== 0) {
        arr.push({
          value: this.balanceInfor.lockAmount,
          name: this.$t('futures.assetsChart.text3'), // '冻结',
          itemStyle: { normal: { color: '#5183BB' } },
          label: { fontFamily: 'Medium' },
        });
      }

      return arr;
    },
  },
  methods: {
    init() {
      this.eachart();
    },
    resetData() {
      if (!this.balanceInfor) return;
      const series = [
        {
          name: '资产',
          type: 'pie',
          radius: ['50%', '75%'],
          avoidLabelOverlap: true,
          data: this.serveData,
        },
      ];
      this.myEcharts.setOption({
        series,
      });
      this.eachart();
    },
    eachart() {
      this.initEachart();
      this.myEcharts.resize();
    },
    initEachart() {
      // 基于准备好的dom，初始化echarts实例
      this.myEcharts = window.echarts.init(document.getElementById('assetsEcharts'));
      // 绘制图表
      this.myEcharts.setOption(
        {
          tooltip: {
            trigger: 'item',
            formatter: '{b} <br/> {c} ({d}%)',
            confine: true,
            textStyle: {
              fontFamily: 'Medium',
            },
          },
          series: [
            {
              name: '资产',
              type: 'pie',
              radius: ['50%', '75%'],
              avoidLabelOverlap: true,
              data: this.serveData,
            },
          ],
        },
      );
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.echart-box {
  width: 100%;
  height: 100%;
}
</style>
